import { render, staticRenderFns } from "./productItemList.vue?vue&type=template&id=a8cf6cfe&scoped=true&"
import script from "./productItemList.vue?vue&type=script&lang=js&"
export * from "./productItemList.vue?vue&type=script&lang=js&"
import style0 from "./productItemList.vue?vue&type=style&index=0&id=a8cf6cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf6cfe",
  null
  
)

export default component.exports